import React, {PropTypes} from 'react';
import TournamentItem from './TournamentItem.jsx';

const TournamentList = ({
  entries,
  onScheduleClick,
  onManageClick
}) => (
  <div className="animated fadeIn flex wrap">
    {entries.map((item, index) => (
      <div
        key={index}
        className="col-sm-6 col-md-4">
        <TournamentItem
          {...item}
          onScheduleClick={onScheduleClick}
          onManageClick={onManageClick}
        />
      </div>
    ))}
  </div>
);

TournamentList.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object),
  onScheduleClick: PropTypes.func,
  onManageClick: PropTypes.func
};

TournamentList.defaultProps = {
  entries: []
};

export default TournamentList;



// WEBPACK FOOTER //
// ./src/features/registration/home/TournamentList.jsx